import { ReactNode, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

type LayoutProps = {
  children: ReactNode;
};

export function Layout({ children }: LayoutProps) {
  // Adjust viewport height for mobile browsers
  useEffect(() => {
    // Function to set the correct viewport height
    const setViewportHeight = () => {
      // Get the viewport height and multiply by 1% to get a value for a vh unit
      const vh = window.innerHeight * 0.01;
      // Set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Set the height initially
    setViewportHeight();

    // Update the height whenever the window resizes
    window.addEventListener('resize', setViewportHeight);
    
    // Clean up
    return () => window.removeEventListener('resize', setViewportHeight);
  }, []);

  return (
    <div className="flex h-[calc(100vh-env(safe-area-inset-bottom,0px))] w-full overflow-hidden" style={{ height: 'calc(var(--vh, 1vh) * 100)' }}>
      <Sidebar />
      <div className="flex flex-col flex-1 min-h-0 w-full">
        <Header />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 w-full pb-safe">{children}</main>
      </div>
    </div>
  );
}

export default Layout;
